import React from 'react';
import styles from './SectionTitle.module.css';

const SectionTitle = ({ 
  title, 
  subtitle,
  align = 'left', // left, center, right
  light = false, // for dark backgrounds
  className = '',
  ...props 
}) => {
  const titleClasses = [
    styles.sectionTitle,
    styles[align],
    light ? styles.light : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={titleClasses} {...props}>
      {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.line}></div>
    </div>
  );
};

export default SectionTitle;